import { render } from "./newCustomerTable.vue?vue&type=template&id=34a5462b&scoped=true"
import script from "./newCustomerTable.vue?vue&type=script&lang=js"
export * from "./newCustomerTable.vue?vue&type=script&lang=js"

import "./newCustomerTable.vue?vue&type=style&index=0&id=34a5462b&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34a5462b"]])

export default __exports__